import { render, staticRenderFns } from "./CragRouteListItem.vue?vue&type=template&id=01452c37"
import script from "./CragRouteListItem.vue?vue&type=script&lang=js"
export * from "./CragRouteListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports